import { IAnalyticsMeta, IWhitelistMetaShape } from '../model'

export const whitelist = (meta: IAnalyticsMeta): IWhitelistMetaShape => ({
  analytics: meta,
})
